import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./insights.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import { insights } from "../../../../CONTENT/insights";

const fmt = (d) =>
  new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });

const Insights = () => {
  const categories = ["All", ...new Set(insights.map((i) => i.category))];
  const [cat, setCat] = useState("All");
  if (!insights.length) return null;

  const list = insights
    .filter((i) => cat === "All" || i.category === cat)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
  const [featured, ...rest] = list;

  return (
    <Section tone="cloud" id="insights" labelledBy="insights-title">
      <SectionIntro
        id="insights-title"
        eyebrow="Insights"
        title="News and perspectives from KUR."
      />
      {categories.length > 2 && (
        <div className={styles.filters} role="group" aria-label="Filter insights">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              aria-pressed={c === cat}
              className={styles.filter}
              onClick={() => setCat(c)}
            >
              {c}
            </button>
          ))}
        </div>
      )}
      <div className={styles.grid}>
        {featured && <Card item={featured} featured />}
        {rest.slice(0, 3).map((i) => (
          <Card key={i.id} item={i} />
        ))}
      </div>
    </Section>
  );
};

const Card = ({ item, featured }) => (
  <article className={`${styles.card} ${featured ? styles.featured : ""}`}>
    <p className={styles.meta}>
      {item.category} · <time dateTime={item.date}>{fmt(item.date)}</time>
    </p>
    <h3 className={styles.title}>
      <Link to={item.href}>{item.title}</Link>
    </h3>
    <p className={styles.excerpt}>{item.excerpt}</p>
    <span className={styles.arrow} aria-hidden="true">→</span>
  </article>
);

export default Insights;
